import React, { useMemo, useEffect } from "react";
import Select from "react-select";
import { getRegions } from "common/services/regions.service";
import { normalize } from "common/lib/normalize";

type FilterProps = {
  onChange: (value: any) => void;
  value: any;
};

const RegionFilter = ({ onChange, value }: FilterProps) => {
  const customSelectStyles = {
    control: (styles: any) => ({
      ...styles,
      borderColor: "#ced4da",
      "&:hover": {
        borderColor: "#ced4da",
      },
    }),
  };

  const [data, setData] = React.useState<any>([]);
  const [loading, setLoading] = React.useState<boolean>(false);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        let filters: any = {
          level: 0,
        };

        const response = await getRegions({
          pagination: {
            page: 1,
            pageSize: 20,
          },
          filters,
        });
        setData(normalize(response.data));
      } catch (e) {
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  const options = useMemo(() => {
    return data.map((el: any) => {
      return {
        value: el?.id,
        label: `${el?.name}`,
      };
    });
  }, [data]);

  return (
    <>
      <Select
        isClearable
        name="region"
        id="region"
        value={value}
        placeholder="Select region"
        onChange={onChange}
        options={options}
        styles={customSelectStyles}
        isLoading={loading}
      />
    </>
  );
};

export default RegionFilter;
